import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache) {
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")

  return (_openBlock(), _createBlock(_component_el_popconfirm, {
    "hide-icon": "",
    "popper-class": "popconfirm"
  }, {
    reference: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3 /* FORWARDED */
  }))
}